// extracted by mini-css-extract-plugin
export default {"investments":"Investments_investments__8xWgP","title":"Investments_title__B3bYh","expand":"Investments_expand__8kuyZ","detail":"Investments_detail__WdSea"};